import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

import SlickCarousel from 'slick-carousel';
import SlickCarouselCss from "slick-carousel/slick/slick-theme.scss";
import SlickCarouselCsss from "slick-carousel/slick/slick.scss";
import ClipboardJS from "clipboard";

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function scrollAdaptive() {

      $(window).on('scroll', function (event) {
        // ヘッダーの高さを取得
        var header_height = $(".l-header").height();
        // elScrollableは別項「スクロール位置の取得」を参照
        var scroll_top = $(window).scrollTop();

        if (scroll_top >= header_height) {
          $("body").addClass("is-scrolling");
          $(".l-header").addClass("is-sticky");
        } else {
          $("body").removeClass("is-scrolling");
          $(".l-header").removeClass("is-sticky");
        }
      });
    }

    function scrollReveal() {
      // スクロールリーバル
      window.sr = new ScrollReveal({duration: 600, mobile: true});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      // scroll add class
      // https://github.com/scrollreveal/scrollreveal/issues/337#issuecomment-309657013
      sr.watch = function (target, onEnter, onExit) {
        onExit = onExit || function () {
        }
        if (typeof onEnter === 'function' && typeof onExit === 'function') {
          var noEffect = {
            delay: 0,
            distance: 0,
            duration: 0,
            scale: 1,
            opacity: null,
            rotate: {x: 0, y: 0, z: 0,},

            reset: true,
            beforeReset: onExit,
            beforeReveal: onEnter,
          }
          this.reveal(target, noEffect)
        } else {
          throw new Error('Watch received invalid arguments.')
        }
      };
      sr.watch('.js-reveal-blur',
        function onEnter(el) {
          el.classList.add('js-reveal-blur-active')
        },
        function onExit(el) {
          // el.classList.remove('js-reveal-blur-active')
        }
      )

      sr.reveal(".c-main-visual__text-01", {
        scale: 1,
        duration: 2000,
        distance: '0',
        delay: 600,
        easing: 'ease-in-out'
      }, 100);
      sr.reveal(".js-reveal-fade", {scale: 1, duration: 1200, distance: '0', delay: 0, easing: 'ease'}, 100);
      sr.reveal(".js-reveal-fade2", {scale: 1, duration: 1200, distance: '0', delay: 300, easing: 'ease'}, 100);
      sr.reveal(".js-reveal-fade3", {scale: 1, duration: 600, distance: '0', delay: 600, easing: 'ease'}, 100);
      sr.reveal(".js-reveal-slide-down", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 0,
        easing: 'ease'
      }, 100);
      sr.reveal(".js-reveal-slide-down2", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 300,
        easing: 'ease'
      }, 100);
      sr.reveal(".js-reveal-slide-down3", {
        scale: 1,
        duration: 1200,
        distance: '20px',
        origin: 'top',
        delay: 600,
        easing: 'ease'
      }, 100);
      sr.reveal(".js-reveal-slide-up", {
        scale: 1,
        duration: 600,
        distance: '20px',
        origin: 'bottom',
        delay: 0,
        easing: 'ease'
      }, 100);
      sr.reveal(".js-reveal-slide-up2", {
        scale: 1,
        duration: 600,
        distance: '20px',
        origin: 'bottom',
        delay: 300,
        easing: 'ease'
      }, 100);
      sr.reveal(".js-reveal-slide-up3", {
        scale: 1,
        duration: 600,
        distance: '20px',
        origin: 'bottom',
        delay: 600,
        easing: 'ease'
      }, 100);


      var blocks01 = $(".js-reveal-chain");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, delay: 500, duration: 400, distance: '10px'}, 100);
        sr.reveal(item.children[1], {
          delay: 500,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[2], {
          delay: 600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[3], {
          delay: 700,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[4], {
          delay: 800,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 10);
        sr.reveal(item.children[5], {
          delay: 900,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[6], {
          delay: 1000,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[7], {
          delay: 1100,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[8], {
          delay: 1200,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[9], {
          delay: 1300,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[10], {
          delay: 1400,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 10);
        sr.reveal(item.children[11], {
          delay: 1500,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[12], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[13], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[14], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[15], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[16], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[17], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[18], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[19], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[20], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[21], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[22], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[23], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[24], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[25], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[26], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
        sr.reveal(item.children[27], {
          delay: 1600,
          scale: 1,
          duration: 400,
          distance: '10px',
          easing: 'ease'
        }, 100);
      });

    }

    function owlCarousel() {
      $('.c-news__inner.owl-carousel').owlCarousel({
        dots: true,
        loop: true,
        autoplay: true,
        autoplaySpeed: 1800,
        autoWidth: false,
        autoHeight: false,
        margin: 32,
        nav: true,
        navText: ['<img src="/wp/wp-content/themes/tokyobiketrip-html/dist/assets/images/img-slider-prev.png" />', '<img src="/wp/wp-content/themes/tokyobiketrip-html/dist/assets/images/img-slider-next.png" />'],
        responsive: {
          0: {
            items: 1,
            dots: true

          },
          950: {
            items: 3,
            dots: true

          }
        }
      });

      $(".c-main-visual .owl-carousel").owlCarousel({
        items: 1,
        dots: false,
        loop: true,
        nav: false,
        autoplay: true,
        autoplaySpeed: 5000,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoWidth: false,
        autoHeight: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false
      });

    }

    function addressbar_adjustment() {
      var w = $(window).width();
      var x = 950;
      if (w <= x) {
        $(".c-mainvisual-slider__item").css({"height": window.innerHeight + "px"});
      }
    }

    function slick() {

      $('.c-image-slider__main').imagesLoaded(function () {
        $('.c-image-slider__main').on('afterChange',function(e,o){
          $('iframe').each(function(){
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
          });
        }).slick({
          infinite: true,
          pauseOnHover: true,
          slidesToShow: 1,
          // variableWidth: true,
          slidesToScroll: 1,
          // centerPadding: "0",
          centerMode: false,
          autoplay: false,
          prevArrow: '<div class="slick-prev"><img src="/wp/wp-content/themes/tokyobiketrip-html/dist/assets/images/img-slider-prev.png"></div>',
          nextArrow: '<div class="slick-next"><img src="/wp/wp-content/themes/tokyobiketrip-html/dist/assets/images/img-slider-next.png"></div>',
          asNavFor: '.c-image-slider__thumbnail',
          autoplaySpeed: 2500,
          responsive: [{
            breakpoint: 750,
            settings: {
              dots: false,
              variableWidth: false,
              autoplaySpeed: 2500,
              slidesToShow: 1
            }
          }]
        });
        $('.c-image-slider__thumbnail').slick({
          accessibility: true,
          autoplay: false,
          autoplaySpeed: 4000,
          speed: 400,
          arrows: false,
          infinite: true,
          //centerMode: false,
          centerMode: true,

          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.c-image-slider__main',
          focusOnSelect: true,
          responsive: [{
            breakpoint: 750,
            settings: {
              dots: false,
              variableWidth: false,
              autoplaySpeed: 2500,
              slidesToShow: 3,
              centerMode: true
            }
          }]
        });

        $('.c-image-slider__subitem').on('click', function () {
          $('.c-image-slider__subitem').removeClass("is-active");
          $(this).addClass("is-active");
        });


        $('.c-slidebar-menu li a').on('click', function () {
          $('body').removeClass("is-slidebar-active");

        });
        $('.c-image-slider').show();

      });

    }
    function imageSlider() {
      var targetInner = $('.c-autoslider__wrapper'),
        targetInnerUl = $('.c-autoslider__wrapper > .c-autoslider__inner'),
        slideEasing = 'linear';
      var slideSpeed = 9000;
      targetInnerUl.clone().prependTo(targetInner);
      targetInnerUl.clone().appendTo(targetInner);
      targetInnerUl.each(function () {
        var self = $(this);
        //liの個数を取得
        var selfChildItemLength = self.find('.c-autoslider__item').length;
        //liの幅を取得
        var selfChildList = self.find('.c-autoslider__item').innerWidth();
        //ulを複製する
        self.clone().appendTo(targetInner);
        //ulの親divに幅を付与する
        targetInner.width((selfChildList * selfChildItemLength) * 2)

        /*
         *
         * 親divをアニメーションさせる
         *
         * */
        function galleryAnimate() {
          targetInner.animate(
            {
              left: '-' + (selfChildList * selfChildItemLength) + 'px'
            }, {
              duration: slideSpeed * selfChildItemLength,
              easing: slideEasing,
              complete: function () {
                targetInner.css({
                  left: '0'
                });
                galleryAnimate()
              }
            }
          );
        }

        galleryAnimate()
      });
    }
    function faqClose() {
      var $btn = $(".c-faq__close");
      var $faqBlock = $(".c-faq__block");
      var $faqText = $(".c-faq__text");
      $btn.on('click',function() {
        $faqText.slideUp();
        if ($faqBlock.hasClass("is-open")){
          $faqBlock.removeClass("is-open");
        }
      });
    }
    function copyToClipboard() {
      var clipboard = new ClipboardJS('.js-clipboard');
      clipboard.on('success', function(e) {
        $(".c-tooltip").slideDown().delay(3000).slideUp();
      });

    }


    $(function () {
      scrollAdaptive();
      scrollReveal();
      owlCarousel();
      addressbar_adjustment();
      imageSlider();
      faqClose();
      slick();
      copyToClipboard();
    });
  }
}

window.GApp = new App();
